/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Iframe_Remote_Import_Failed_TextInputs */

const en_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Project import failed. ${i?.error}`)
};

const fr_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Echec de l'importation du projet. ${i?.error}`)
};

const de_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Projektimport fehlgeschlagen. ${i?.error}`)
};

const it_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Importazione del progetto non riuscita. ${i?.error}`)
};

const ru_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Импорт проекта не удался. ${i?.error}`)
};

const es_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Error en la importación del proyecto. ${i?.error}`)
};

const zh_cn2_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`项目导入失败。${i?.error}`)
};

const ja_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポートに失敗しました。${i?.error}`)
};

const hi_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`प्रोजेक्ट आयात विफल रहा। ${i?.error}`)
};

const pt_pt2_iframe_remote_import_failed_text = /** @type {(inputs: Iframe_Remote_Import_Failed_TextInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A importação do projeto falhou. ${i?.error}`)
};

/**
* | output |
* | --- |
* | "Project import failed. {error}" |
*
* @param {Iframe_Remote_Import_Failed_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iframe_remote_import_failed_text = /** @type {((inputs: Iframe_Remote_Import_Failed_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iframe_Remote_Import_Failed_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iframe_remote_import_failed_text(inputs)
	if (locale === "de") return de_iframe_remote_import_failed_text(inputs)
	if (locale === "it") return it_iframe_remote_import_failed_text(inputs)
	if (locale === "ru") return ru_iframe_remote_import_failed_text(inputs)
	if (locale === "es") return es_iframe_remote_import_failed_text(inputs)
	if (locale === "zh-CN") return zh_cn2_iframe_remote_import_failed_text(inputs)
	if (locale === "ja") return ja_iframe_remote_import_failed_text(inputs)
	if (locale === "hi") return hi_iframe_remote_import_failed_text(inputs)
	if (locale === "pt-PT") return pt_pt2_iframe_remote_import_failed_text(inputs)
	return en_iframe_remote_import_failed_text(inputs)
});